import React from 'react';

// CTA Strip Section
const CTAStripSection = ({ data }) => {
  const { 
    heading, 
    subheading,
    cta_label, 
    cta_link,
    secondary_cta_label,
    secondary_cta_link,
    background_color = '#000000',
    text_color = '#ffffff'
  } = data || {};
  
  return (
    <section 
      className="py-16 px-4"
      style={{ backgroundColor: background_color, color: text_color }}
    >
      <div className="max-w-4xl mx-auto text-center">
        {heading && (
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {heading}
          </h2>
        )}
        {subheading && (
          <p className="text-lg md:text-xl opacity-90 mb-8">
            {subheading}
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {cta_label && cta_link && (
            <a
              href={cta_link}
              className="inline-block bg-white text-black px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              {cta_label}
            </a>
          )}
          {secondary_cta_label && secondary_cta_link && (
            <a
              href={secondary_cta_link}
              className="inline-block border-2 border-current px-8 py-3 rounded-lg font-medium hover:bg-white/10 transition-colors"
            >
              {secondary_cta_label}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTAStripSection;
